/**
 * Mark all notification-bearing APs as "just opened" so seed-day-fresh
 * records and pre-existing pending docs don't ring notifications after a
 * demo bootstrap. The Substanz-Radar finding still surfaces because its
 * badge counts open findings rather than gating on lastOpenedAt.
 *
 * Single source of truth for both the Configuration AP `Anwenden`
 * post-commit handler and the manual "Demo zurücksetzen" button.
 */
export function virtuallyOpenAllAPs(): void {
  try {
    const now = String(Date.now())
    for (const id of ['supplier', 'customer-conformity', 'substanz-radar']) {
      localStorage.setItem(`qms.ap.lastOpenedAt.${id}`, now)
    }
  } catch {
    // best-effort — localStorage unavailable in some embedded contexts
  }
}
